import { ISignalPlanVisual } from "@types"
import { protectedApi } from "store/Api";

interface IFetchSignalPlanVisualArgs {
  beginDate: string;
  endTime: string;
  deviceIds: number[];
}


const signalPlanVisualApi = protectedApi.injectEndpoints({

  endpoints: (builder) => ({
    fetchSignalPlanVisual: builder.mutation<ISignalPlanVisual[], IFetchSignalPlanVisualArgs>({
      query: ({ beginDate, endTime, deviceIds }) => {
        return {
          method: "GET",
          url: `data/signal_plan/analysis?beginDate=${beginDate}&endTime=${endTime}&deviceId=[${deviceIds}]`,
        }
      },
    }),
  }),
})

export const { useFetchSignalPlanVisualMutation } = signalPlanVisualApi
